import { Expose } from "class-transformer";

export class CreateClientTypeDto {
  @Expose()
  name: string;

  @Expose()
  isInternal: boolean;
}
